<template>
  <div class="whs-detail-map" ref="map">
    <!-- <div class="whs-map-toggler whs-icon" @click="toggleMap"></div> -->
    <div id="map"></div>
  </div>
</template>

<script>
import 'vue2-leaflet';

const L = window.L;

export default {
  name: 'Map',
  data: function() {
    return { map: null, marker: null };
  },
  watch: {
    longitude() {
      this.includeMap();
    }
  },
  props: {
    longitude: Number,
    latitude: Number
  },
  methods: {
    includeMap() {
      if (!this.map) {
        this.map = L.map('map');
        this.map.scrollWheelZoom.disable();
        L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(this.map);
      }

      this.map.setView([this.latitude, this.longitude], 14);
      this.map.eachLayer(layer => {
        if (!(layer instanceof L.TileLayer)) this.map.removeLayer(layer);
      });
      this.marker = L.marker([this.latitude, this.longitude]).addTo(this.map);
    }
  },
  mounted() {
    this.includeMap();
    // this.clearMarkers();
    // this.addMarkers(this.hotels);
  }
};
</script>

<style scoped>
.whs-detail-map {
  width: 100%;
  height: 300px;
  z-index: 0;
  position: relative;
}
#map {
  width: 100%;
  height: 100%;
}
</style>